var map = {
	"./audio_3_0.mp3": 1366,
	"./audio_3_1.mp3": 1367,
	"./audio_3_2.mp3": 1368,
	"./audio_3_3a.mp3": 1369,
	"./audio_3_3b.mp3": 1370,
	"./audio_3_3c.mp3": 1371,
	"./audio_3_3d.mp3": 1372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1365;